import { RouterProvider } from '@tanstack/react-router';
import { FseThemeProvider } from '@fse/ui';

import { router } from './router';

export function App() {
  return (
    <FseThemeProvider>
      <RouterProvider router={router} />
    </FseThemeProvider>
  );
}
